import { SpotType } from 'src/types';

// Tattoo Spots
export const SPOTS: SpotType[] = [
	{
		link: '/koi',
		title: 'Koi',
		x: 0.35,
		y: 0.37,
	},
	{
		link: '/dragon',
		title: 'Dragon',
		x: 0.65,
		y: 0.37,
	},
	{
		link: '/melody',
		title: 'Melody',
		x: 0.35,
		y: 0.7,
	},
];
